var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedPurchaseOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.9583 7.99992H10L9.625 6.16659C9.54167 5.70825 9.125 5.33325 8.66667 5.33325H4.5C4.20833 5.33325 4 5.58325 4 5.83325V6.83325C4 7.12492 4.20833 7.33325 4.5 7.33325H7.83333L10.7083 22.1666C10.25 22.6666 10 23.2916 10 23.9999C10 25.4999 11.1667 26.6666 12.6667 26.6666C14.125 26.6666 15.3333 25.4999 15.3333 23.9999C15.3333 23.5416 15.1667 23.0833 14.9583 22.6666H21C20.7917 23.0833 20.6667 23.5416 20.6667 23.9999C20.6667 25.4999 21.8333 26.6666 23.3333 26.6666C24.7917 26.6666 26 25.4999 26 23.9999C26 23.2499 25.6667 22.5833 25.1667 22.0833L25.2083 21.9166C25.3333 21.2916 24.875 20.6666 24.2083 20.6666H12.4583L12.0833 18.6666H25.0833C25.5833 18.6666 25.9583 18.3749 26.0833 17.9166L27.9583 9.24992C28.0833 8.62492 27.625 7.99992 26.9583 7.99992ZM12.6667 24.9999C12.0833 24.9999 11.6667 24.5833 11.6667 23.9999C11.6667 23.4583 12.0833 22.9999 12.6667 22.9999C13.2083 22.9999 13.6667 23.4583 13.6667 23.9999C13.6667 24.5833 13.2083 24.9999 12.6667 24.9999ZM23.3333 24.9999C22.75 24.9999 22.3333 24.5833 22.3333 23.9999C22.3333 23.4583 22.75 22.9999 23.3333 22.9999C23.875 22.9999 24.3333 23.4583 24.3333 23.9999C24.3333 24.5833 23.875 24.9999 23.3333 24.9999ZM24.2917 16.6666H11.6667L10.375 9.99992H25.75L24.2917 16.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPurchaseOrder);
export default __webpack_public_path__ + "static/media/Selected Purchase Order.1d8b026ea10cfae50fae8267be1dda5c.svg";
export { ForwardRef as ReactComponent };